import React from 'react';
import { X, Mail, Copy } from 'lucide-react';
import { Button } from './ui/button';
import { useToast } from '../hooks/use-toast';

const EmailModal = ({ isOpen, onClose }) => {
  const { toast } = useToast();
  const emailAddress = 'customer-service@edgetrades.site';

  const copyEmail = () => {
    navigator.clipboard.writeText(emailAddress);
    toast({
      title: 'Copied!',
      description: 'Email address copied to clipboard'
    });
  };

  const openEmailClient = () => {
    window.location.href = `mailto:${emailAddress}?subject=Support Request&body=Hello Support Team,`;
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 border-2 border-cyan-500/40 rounded-2xl p-6 max-w-md w-full shadow-2xl shadow-cyan-500/20">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-purple-600 flex items-center justify-center">
              <Mail className="w-6 h-6 text-white" />
            </div>
            <h2 className="text-xl font-bold text-cyan-400">Contact Support</h2>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full bg-slate-800/50 hover:bg-slate-700 flex items-center justify-center transition-colors"
          >
            <X className="w-5 h-5 text-cyan-400" />
          </button>
        </div>

        {/* Content */}
        <div className="space-y-4">
          <p className="text-cyan-300 text-sm">
            Send us an email and we'll get back to you as soon as possible!
          </p>

          {/* Email Address */}
          <div className="bg-slate-800/50 border border-cyan-500/30 rounded-lg p-4">
            <label className="text-cyan-600 text-xs mb-2 block">Email Address</label>
            <div className="flex items-center gap-2">
              <p className="text-cyan-100 font-mono text-sm flex-1">{emailAddress}</p>
              <button
                onClick={copyEmail}
                className="w-8 h-8 rounded-lg bg-cyan-500/20 hover:bg-cyan-500/30 flex items-center justify-center transition-colors"
              >
                <Copy className="w-4 h-4 text-cyan-400" />
              </button>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="space-y-2">
            <Button
              onClick={openEmailClient}
              className="w-full h-12 bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white font-semibold"
            >
              <Mail className="w-5 h-5 mr-2" />
              Open Email Client
            </Button>
            
            <p className="text-center text-cyan-600 text-xs">
              If the email client doesn't open, please copy the email address above
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailModal;
